import React from 'react';
import { color, boxShadow } from '../constants';
import styled from 'styled-components';
import { RaosWrapper } from 'raos';
import { Container, Row, Col } from 'react-bootstrap';
import advanced from '../imnages/advanced.png';

const DetailCont = styled.div`
  margin-top: 2rem;
  padding: 1rem;
  box-shadow: ${boxShadow.outset};
  border-radius: .5rem;
`
const Title = styled.h2`
  display: inline-block;
  text-transform: uppercase;
  border-bottom: 5px solid ${color.prim};
  padding: .5rem 0;
`
const SubTitle = styled.h3`
  text-transform: uppercase;
  padding: .5rem 0;
  margin: 0;
`
const InfoCont = styled.div`
  padding: 1rem;
  border-radius: .5rem;
  box-shadow: ${boxShadow.inset};
`
const CodeImg = styled.img`
  width: 100%;
  object-fit: cover;
  object-position: center;
`
const Info = styled.p`
  text-align: justify;
  margin: 0;
`
export default ()=> {

  return(
    <Container>
      <RaosWrapper className="animated bounce">
        <DetailCont>
          <Title>advanced</Title>
          <InfoCont>
            <Row>
              <Col className="d-flex align-items-center" xs={12} sm={6}>
                <CodeImg src={advanced} alt="detailed code" />
              </Col>
              <Col xs={12} sm={6}>
                <SubTitle>1-import</SubTitle>
                <Info>Import useObserver hook from raos.</Info>
                <SubTitle>2-Use it</SubTitle>
                <Info>use it as you would use useState, you could pass it a threshold, which would be a number between 0 and 1, where 1 is the total interception point of your component or 100%, default id 0.25(25%), you could pass it 0, 0.25(25%), 0.5(50%), etc. . When the component is intercepted, <span style={{ fontWeight: "bold" }}>observe</span> returns the value of true, allowing gsap to run the specified animation.</Info>
                <SubTitle>3-Observed component</SubTitle>
                <Info>assign the component to intercept with setObserve as you would with useRef.</Info>
              </Col>
            </Row>
          </InfoCont>
        </DetailCont>
      </RaosWrapper>
    </Container>
  )
}
